import React from 'react'
import PropTypes from 'prop-types'
import { SecondaryButton, TransparentBgButton } from './Button'
import { useTranslation } from 'react-i18next'

export default function ConfirmationModal(props) {
  const { title, description, onCancel, onConfirm, cancelText, confirmText, isLoading } = props
  const { t } = useTranslation()

  const getConfirmButtonText = () => {
    if (isLoading) {
      return t('common.loading')
    }
    return confirmText || t('common.yesProceed')
  }

  return (
    <div className='confirm-modal'>
      <div className='confirm-modal_content'>
        <h1>{title}</h1>

        <p>{description}</p>
      </div>

      <div className='confirm-modal_footer'>
        <TransparentBgButton 
          color='navy' 
          text={cancelText || t('common.cancel')} 
          onClick={onCancel} 
          disabled={isLoading}
        />

        <SecondaryButton 
          text={getConfirmButtonText()} 
          onClick={onConfirm} 
          disabled={isLoading}
        />
      </div>
    </div>
  )
}

ConfirmationModal.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
}